var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('register-credential-tef',{ref:"RegisterCredentialTef"}),_c('register-bines-tef',{ref:"RegisterBinesTef"}),_c('show-credentials-tef',{ref:"ShowCredentialsTef"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }